import React, { useState, useEffect } from "react";
import { ethers } from "ethers";
import AuctionRegistryABI from "../../utils/AuctionRegistry.json";
import MedicalServiceAuctionABI from "../../utils/MedicalServiceAuction.json";
import { Card, CardBody, Typography, Chip,
  CardHeader,
  CardFooter, Button} from "@material-tailwind/react";

export function PatientServiceListExpanded() {
  const auctionRegistryAddress =  process.env.REACT_APP_REGISTRY_CONTRACT_ADDRESS; // Replace with your address
  const [details, setDetails] = useState([]);

  // Function to fetch auction details
  const fetchAuctionDetails = async (auctionContractAddress) => {
    console.log("Auction Contract Address:", auctionContractAddress);
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const auctionContract = new ethers.Contract(
        auctionContractAddress,
        MedicalServiceAuctionABI,
        provider
      );
      
      return await auctionContract.getAuctionDetails();
    } catch (error) {
      console.error("Error fetching auction details:", error);
      throw error; // Rethrow the error if you want to handle it further up the call stack
    }
  };
  

  // Function to fetch all auctions for the patient and their details
  const getAllBids = async () => {
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const registryContract = new ethers.Contract(
        auctionRegistryAddress,
        AuctionRegistryABI,
        signer
      );
      const connectedAddress = await signer.getAddress();
      const auctionAddresses = await registryContract.getAuctionsForPatient(connectedAddress);
      console.log(auctionAddresses)
      const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
      const auctionDetails = await Promise.all(
        auctionAddresses.map(async (address) => {
          const details = await fetchAuctionDetails(address);
          let biddingEndTime = details._biddingEndTime;
        
        // Convert BigNumber to number if necessary
        if (ethers.BigNumber.isBigNumber(biddingEndTime)) {
          biddingEndTime = biddingEndTime.toNumber();
        }

        const hasAuctionEnded = details._auctionEnded || biddingEndTime < currentTime;
          return {
            patient: details._patient,
            service: details._service,
            biddingEndTime: details._biddingEndTime,
            minBudget: details._minBudget,
            maxBudget: details._maxBudget,
            location: details._location,
            auctionEnded: hasAuctionEnded
          };
        })
      );

      setDetails(auctionDetails);
    } catch (error) {
      console.error("Error fetching auction data:", error);
    }
  };

  useEffect(() => {
    getAllBids();
  }, []); // Runs once after component mounts

  return (
    <div className="flex flex-wrap">
      {details.map((detail, index) => (
        <div key={index} className="w-full sm:w-1/2 md:w-1/2 lg:w-1/2 p-2">
          <Card className="mx-auto mt-6 w-full sm:w-3/4">
          <CardHeader color="blue-gray" className="relative h-56">
        <img
          src="https://images.unsplash.com/photo-1559000357-f6b52ddfbe37?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDR8fGhvc3BpdGFsfGVufDB8fDB8fHww"
          alt="card-image"
        />
      </CardHeader>
            <CardBody>
            <Typography variant="h3">{detail.service}</Typography>
              <Typography>
                <p><strong>Bidding End Time:</strong> {new Date(detail.biddingEndTime * 1000).toLocaleString()}</p>
                <p><strong>Min Budget:</strong> ${detail.minBudget.toString()}</p>
                <p><strong>Max Budget:</strong> ${detail.maxBudget.toString()}</p>
                <p><strong>Location:</strong> {detail.location}</p>
                <Chip
                  color={detail.auctionEnded ? "red" : "green"}
                  value={detail.auctionEnded ? "Auction Ended" : "Active"} 
                />
              </Typography>
            </CardBody>
          </Card>
        </div>
      ))}
    </div>
  );
}
